export { default as MarketingBasicTile } from './marketing-basic-tile';
